import { useEffect } from 'react';
import { useRouter } from 'next/router';
import { Translate } from 'next-translate';

import { useGlobalProductDetails, useGlobalSnackBar } from '../../../common/hooks';
import { Product } from '../../../service/types';
import { URLS } from '../../../common/constants';
import { replaceRoute } from '../../../common/utils';

type UseScriptType = (args: { t: Translate; products: Partial<Product>[] }) => void;

const useShowItemNotPublished: UseScriptType = ({ t, products }) => {
  const router = useRouter();
  const [snackBarDetails, setSnackBarDetails] = useGlobalSnackBar();
  const [, setGlobalProductDetails] = useGlobalProductDetails();
  const { notPublished, ...restOfTheQuery } = router?.query;

  useEffect(() => {
    if (notPublished) {
      setGlobalProductDetails({});
      setSnackBarDetails({
        show: true,
        setShowSnackBar: () => snackBarDetails.setShowSnackBar(true),
        autoHide: true,
        message: t('itemNotPublished'),
        onHide: () => {
          setSnackBarDetails({
            show: false,
            setShowSnackBar: () => snackBarDetails.setShowSnackBar(false),
          });
          replaceRoute({ pathname: URLS.CATEGORY_PRODUCTS, query: restOfTheQuery }, { shallow: true });
        },
      });
    }
  }, [notPublished, products]);
};

export default useShowItemNotPublished;
